import React, { Fragment } from 'react';
import Grid from '../../../../components/Grid';
import { Subscription, ProductDescription, ProductLogo, ProductSection, SUBSCRIPTION_TYPE } from './ActivationContent';
var PapertrailVisibility = "https://cdn.solarwinds.cloud/cloud-ui/assets/papertrail-visibility-28da4f68750475521c1a333451c9a87e.svg";
var PapertrailTroubleshoot = "https://cdn.solarwinds.cloud/cloud-ui/assets/papertrail-troubleshoot-5da3a7e5764942004eb9fa0c0cd6fe5b.svg";
var PapertrailAnalysis = "https://cdn.solarwinds.cloud/cloud-ui/assets/papertrail-analysis-ab8da01532671120d9ae05f6837eee8f.svg";
var PapertrailLogo = "https://cdn.solarwinds.cloud/cloud-ui/assets/papertrail-logo-21679171eb7eebab71b4e99a23e98565.svg";
export var PapertrailContent = function PapertrailContent(_ref) {
  var productStatus = _ref.productStatus;
  return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(ProductLogo, {
    logo: PapertrailLogo
  }), /*#__PURE__*/React.createElement(ProductDescription, {
    title: "Aggregate all your logs, your own way.",
    content: "Thousands of companies trust Papertrail to manage billions of log messages every day. Consolidate your logs in one place with cloud-hosted log management service that typically takes only minutes to set up."
  }), /*#__PURE__*/React.createElement(Grid.Row, null, /*#__PURE__*/React.createElement(ProductSection, {
    image: PapertrailVisibility,
    title: "Instant Visibility",
    content: "Consolidate syslog, text log files, Apache, Windows events, cloud hosting, MySQL, and more."
  }), /*#__PURE__*/React.createElement(ProductSection, {
    image: PapertrailTroubleshoot,
    title: "Troubleshoot Faster",
    content: "Search large volumes of streaming or stored log messages in a flash with our lightning search cabability."
  }), /*#__PURE__*/React.createElement(ProductSection, {
    image: PapertrailAnalysis,
    title: "In-depth Analysis",
    content: "With log velocity analytics, visualize log throughput to quickly identify patterns and anomalies."
  })), /*#__PURE__*/React.createElement(Subscription, {
    productStatus: productStatus,
    type: SUBSCRIPTION_TYPE.FREE
  }));
};